export const DO_USER_LOGIN = 'DO_USER_LOGIN';
export const USER_LOGIN_PROCESS_FINISHED = 'USER_LOGIN_PROCESS_FINISHED';

export const TYPING_USER_PROFILE = 'TYPING_USER_PROFILE'; // client side

export const USER_IS_LOGGED_IN = 'USER_IS_LOGGED_IN';
export const USER_IS_LOGGED_OUT = 'USER_IS_LOGGED_OUT';

export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const USER_PASSWORD_RESETTED = 'USER_PASSWORD_RESETTED';
export const USER_PASSWORD_RESET = 'USER_PASSWORD_RESET';
export const USER_PASSWORD_RESET_FAILED = 'USER_PASSWORD_RESET_FAILED';
export const USER_EMAIL_CHANGED = 'USER_EMAIL_CHANGED';
export const USER_FORGOT_PASSWORD_FORM_RESET = 'USER_FORGOT_PASSWORD_FORM_RESET';
export const SET_RESET_PASSWORD_FORM = 'SET_RESET_PASSWORD_FORM';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GOT_USER_PROFILE = 'GOT_USER_PROFILE';
export const RESET_USER_PROFILE = 'RESET_USER_PROFILE';
export const UPDATE_USER_PROFILE_NEW_EMAIL = 'UPDATE_USER_PROFILE_NEW_EMAIL';

// MY ROLES
export const GET_MY_ROLES = 'GET_MY_ROLES';
export const GOT_MY_ROLES = 'GOT_MY_ROLES';
export const ERROR_GETTING_MY_ROLES = 'ERROR_GETTING_MY_ROLES';
export const REMOVE_ROLE = 'REMOVE_ROLE';
export const UNDO_REMOVE_ROLE = 'UNDO_REMOVE_ROLE';
export const UNDO_REMOVE_ALL_ROLE = 'UNDO_REMOVE_ALL_ROLE';
export const REMOVE_ALL_ROLE = 'REMOVE_ALL_ROLE';
export const ERROR_UPDATING_MY_ROLES = 'ERROR_UPDATING_MY_ROLES';
export const UPDATED_MY_ROLES = 'UPDATED_MY_ROLES';

//END MY ROLES

//CHANGE PASSWORD
export const SET_CHANGE_PASSWORD_FORM = 'SET_CHANGE_PASSWORD_FORM';
//END CHANGE PASSWORD

//RESET PASSWORD VIA TOKEN
export const RESET_PASSWORD_TOKEN_FORM = 'RESET_PASSWORD_TOKEN_FORM';
export const SET_RESET_PASSWORD_TOKEN = 'SET_RESET_PASSWORD_TOKEN';
//END RESET PASSWORD VIA TOKEN

export const GET_USER_BASIC_PROFILE = 'GET_USER_BASIC_PROFILE';
export const GOT_USER_BASIC_PROFILE = 'GOT_USER_BASIC_PROFILE';
export const ERROR_GETTING_USER_BASIC_PROFILE = 'ERROR_GETTING_USER_BASIC_PROFILE';
export const USER_CALL_STATUS_CHANGED = 'USER_CALL_STATUS_CHANGED';

export const GET_TIMEZONES = 'GET_TIMEZONES';
export const GOT_TIMEZONES = 'GOT_TIMEZONES';
export const SAVE_USER = 'SAVE_USER';
export const SAVED_USER = 'SAVED_USER';
export const CHANGE_USER_IMAGE = 'CHANGE_USER_IMAGE';
export const IGNORE_RELOAD_USER_IMAGE = 'IGNORE_RELOAD_USER_IMAGE';
export const SET_PROFILE_IMAGE_DROPPED = 'SET_PROFILE_IMAGE_DROPPED';
export const RESET_IMAGE = 'RESET_IMAGE';
export const RESET_IMAGE_TO_DEFAULT = 'RESET_IMAGE_TO_DEFAULT';

export const GET_NOT_ME_USER_PROFILE = 'GET_NOT_ME_USER_PROFILE';
export const GOT_NOT_ME_USER_PROFILE = 'GOT_NOT_ME_USER_PROFILE';

export const GOT_WAITING_AREA_USERS = 'GOT_WAITING_AREA_USERS';
export const ERROR_GETTING_WAITING_AREA_USERS = 'ERROR_GETTING_WAITING_AREA_USERS';

// User Signup

export const SET_WA_USER_SIGNUP_FORM = 'SET_WA_USER_SIGNUP_FORM';
export const RESET_WA_USER_SIGNUP_FORM = 'RESET_WA_USER_SIGNUP_FORM';

// Add new user
export const SEARCH_SELECT_USERS_FORM = {
  LOADING_SUGGESTIONS: 'SEARCH_SELECT_USERS_FORM.LOADING_SUGGESTIONS',
  SHOW_SUGGESTIONS: 'SEARCH_SELECT_USERS_FORM.SHOW_SUGGESTIONS',
  ERROR_GETTING_SUGGESTIONS: 'SEARCH_SELECT_USERS_FORM.ERROR_GETTING_SUGGESTIONS',
  CLEAR_SUGGESTIONS: 'SEARCH_SELECT_USERS_FORM.CLEAR_SUGGESTIONS',
  SELECT_USER: 'SEARCH_SELECT_USERS_FORM.SELECT_USER',
  SELECT_SINGLE_USER: 'SEARCH_SELECT_USERS_FORM.SELECT_SINGLE_USER',
  UNSELECT_USER: 'SEARCH_SELECT_USERS_FORM.UNSELECT_USER',
  CLEAR_FORM: 'SEARCH_SELECT_USERS_FORM.CLEAR_FORM',
};

export const AUTHENTICATE_API = 'authenticate';

//Organisation User
export const GOT_ORGANISATIONAL_UNIT_USERS = 'GOT_ORGANISATIONAL_UNIT_USERS';
export const ERROR_GETTING_ORGANISATIONAL_UNIT_USERS = 'ERROR_GETTING_ORGANISATIONAL_UNIT_USERS';

// Manage user for users lists
export const UPDATE_SELECTED_USER_FOR_MANAGEMENT = 'UPDATE_SELECTED_USER_FOR_MANAGEMENT';

// Meeting room manage users
export const GOT_MEETING_ROOM_USERS = 'GOT_MEETING_ROOM_USERS';

// Get all users for admins
export const GOT_ALL_USERS_FOR_ADMIN = 'GOT_ALL_USERS_FOR_ADMIN';
export const UPDATE_SINGLE_USERS_FOR_ADMIN = 'UPDATE_SINGLE_USERS_FOR_ADMIN';
export const UPDATE_SELECTED_USER_FOR_ALL_USERS = 'UPDATE_SELECTED_USER_FOR_ALL_USERS';
export const ERROR_GETTING_ALL_USERS_FOR_ADMIN = 'ERROR_GETTING_ALL_USERS_FOR_ADMIN';
export const ERROR_GETTING_SINGLE_USERS_FOR_ADMIN = 'ERROR_GETTING_SINGLE_USERS_FOR_ADMIN';
export const UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ALL_USERS = 'UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ALL_USERS';
export const UPDATE_ALL_USERS_SEARCH_BAR = 'UPDATE_ALL_USERS_SEARCH_BAR';
export const RESET_ALL_USERS_SEARCH_FROM = 'RESET_ALL_USERS_SEARCH_FROM';
export const UPDATE_ALL_USERS_SEARCH_FROM = 'UPDATE_ALL_USERS_SEARCH_FROM';
// Get User's Profile by userId
export const ERROR_GETTING_USER_PROFILE = 'ERROR_GETTING_USER_PROFILE';
export const GOT_USER_PROFILE_BY_USERID = 'GOT_USER_PROFILE_BY_USERID';
// Manage other user's role
export const UPDATE_HAS_ROLES_IN_OTHER_NETWORKS = 'UPDATE_HAS_ROLES_IN_OTHER_NETWORKS';
export const ERROR_UPDATING_OTHER_ROLES = 'ERROR_UPDATING_OTHER_ROLES';
export const RESET_MY_ROLES = 'RESET_MY_ROLES';

// Manage user Invitations
export const GOT_USER_INVITATIONS = 'GOT_USER_INVITATIONS';
export const ERROR_GETTING_USER_INVITATIONS = 'ERROR_GETTING_USER_INVITATIONS';
export const INTEND_TO_REMOVE_INVITED_ROLE = 'INTEND_TO_REMOVE_INVITED_ROLE';
export const UNDO_REMOVE_INVITED_ROLE = 'UNDO_REMOVE_INVITED_ROLE';
export const CLEAR_USER_INVITATION_FORM = 'CLEAR_USER_INVITATION_FORM';
export const ERROR_RESEND_INVITATION_BY_USERID = 'ERROR_RESEND_INVITATION_BY_USERID';
export const REMOVE_ALL_INVITED_ROLES = 'REMOVE_ALL_INVITED_ROLES';
export const UNDO_REMOVE_ALL_INVITED_ROLES = 'UNDO_REMOVE_ALL_INVITED_ROLES';
export const ERROR_CANCEL_INVITATION_BY_USERID = 'ERROR_CANCEL_INVITATION_BY_USERID';
export const ERROR_GETTING_USER_CALLs_DETAILS = 'ERROR_GETTING_USER_CALLs_DETAILS';
export const GOT_USER_CALLS_DETAILS = 'GOT_USER_CALLS_DETAILS';

import fc from '../businessLogic/fetchInterceptor';
import { displayGlobalMessage } from '../actions/globalMessage';
import { getWaitingArea, checkUpdatesForDirectAssociatedWAs } from '../actions/waitingArea';
import { getOrganisationById } from './organisation';
import { getMeetingRoomWithSearchTerm } from './meetingRoom';
import { subscribeForPubNubUpdates } from './pubnub/init';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import objectAssign from 'object-assign';
import _ from 'lodash';

export function typingUserProfile(currentProfile) {
  return (dispatch) => {
    dispatch({ type: TYPING_USER_PROFILE, data: currentProfile });
  };
}

export function getNotMeUserProfile(id, cb) {
  return (dispatch) => {
    dispatch({ type: GET_NOT_ME_USER_PROFILE, data: id });
    fc.get('/' + 'users' + id + '.json')
      .then((data) => {
        setTimeout(function () {
          let res = dispatch({ type: GOT_NOT_ME_USER_PROFILE, data: data });
          if (cb) cb();
          return res;
        }, 3000);
        console.warn('artificial load, must remove');
      })
      .catch((err) => console.error('There was an API error', err));
  };
}

export function getUserProfile(cb) {
  return (dispatch) => {
    dispatch({ type: GET_USER_PROFILE });
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'users')
      .then((data) => {
        let res = dispatch({ type: GOT_USER_PROFILE, data: data });
        if (cb) cb();
        return res;
      })
      .catch((err) => {
        if (err && err == 'failed to fetch') window.$('#overlay').hide();
        console.error('There was an API error', err);
      });
  };
}
export function resetUserProfile() {
  return (dispatch) => {
    dispatch({ type: RESET_USER_PROFILE });
  };
}

export function getUserBasicProfile(cb, calledByPubNubNotification = false) {
  return (dispatch) => {
    dispatch({ type: GET_USER_BASIC_PROFILE });
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'users/basicinfo')
      .then((data) => {
        // subscribe for future updates for this user from pubnub
        subscribeForPubNubUpdates(data, dispatch, calledByPubNubNotification);
        let res = dispatch({ type: GOT_USER_BASIC_PROFILE, data: data });
        if (calledByPubNubNotification) {
          dispatch(checkUpdatesForDirectAssociatedWAs(data));
        }
        if (cb) cb(res.data, dispatch);
        return res;
      })
      .catch((err) => {
        if (err && err == 'failed to fetch') window.$('#overlay').hide();
        console.error('There was an API error', err);
        return dispatch({ type: ERROR_GETTING_USER_BASIC_PROFILE });
      });
  };
}

export function getTimezones(cb) {
  return (dispatch) => {
    dispatch({ type: GET_TIMEZONES });
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'TimeZone')
      .then((data) => {
        let res = dispatch({ type: GOT_TIMEZONES, data: data });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an API error', err.toString()));
  };
}

export function userLogin(user, callback, error) {
  return (dispatch) => {
    // Dispatch an event saying login action is in progress
    dispatch({ type: DO_USER_LOGIN });

    // Call the API to authenticate login details
    fc.post(window.APP.CONFIGURATION.VCCAPI + AUTHENTICATE_API, {
      body: JSON.stringify(user),
    })
      .then((data) => {
        if (data != undefined) {
          callback(data);

          // Dispatch an event saying login action has succeded
          return dispatch({
            type: LOGIN_SUCCESS,
            data: data || {},
          });
        } else {
          // Dispatch an event saying login action has failed
          return dispatch({ type: LOGIN_FAILED });
        }
      })
      .catch((err) => {
        error(err); // Only show if unauthorized
        console.error('There was an API error', err.toString());
        return dispatch({ type: LOGIN_FAILED });
      });
  };
}

export function userVerifyEmail({ username, password, rememberMe }, callback, error) {
  return (dispatch) => {
    // Dispatch an event saying login action is in progress
    dispatch({ type: DO_USER_LOGIN });

    let urlParams = new URLSearchParams(window.location.search);
    let authTokenId = urlParams.get('t');

    // Call the API to authenticate Alternate login details
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'authenticate/alterLogin', {
      body: JSON.stringify({
        authTokenId,
        username,
        password,
        rememberMe,
      }),
    })
      .then((data) => {
        if (data != undefined) {
          callback(data);

          // Dispatch an event saying login action has succeded
          return dispatch({
            type: LOGIN_SUCCESS,
            data: data || {},
          });
        } else {
          // Dispatch an event saying login action has failed
          error();
          return dispatch({ type: LOGIN_FAILED });
        }
      })
      .catch((err) => {
        if (err == 401 || err.toLowerCase() == 'unauthorized') error(err); // Only show if unauthorized
        console.error('There was an API error', err.toString());
        return dispatch({ type: LOGIN_FAILED });
      });
  };
}

export function userLoggedInProcessFinished() {
  return (dispatch) => {
    dispatch({ type: USER_LOGIN_PROCESS_FINISHED });
  };
}

export function userEmailUpdated(user) {
  return (dispatch) => {
    dispatch({ type: USER_EMAIL_CHANGED, data: user });
  };
}
export function resetForgotPasswordForm(user) {
  return (dispatch) => {
    dispatch({ type: USER_FORGOT_PASSWORD_FORM_RESET });
  };
}
/////////////////////CHANGE PASSWORD//////////////////////////////////////
export function setChangePasswordForm(changePassword) {
  return (dispatch) => {
    dispatch({ type: SET_CHANGE_PASSWORD_FORM, data: changePassword });
  };
}

export function requestChangePassword(dataToSave, userEmail, callback, error) {
  return (dispatch) => {
    dispatch({ type: USER_PASSWORD_RESET });
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'Users/changePassword', {
      body: JSON.stringify(dataToSave),
    })
      .then(() => {
        dispatch({ type: USER_PASSWORD_RESETTED });
        var msg = APP.LANGUAGE.ResetPassword.ChangePasswordSuccess.replace('##userEmail##', userEmail);
        dispatch(
          displayGlobalMessage({
            text: msg,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (callback) callback();
      })
      .catch((err) => {
        dispatch({ type: USER_PASSWORD_RESET_FAILED });
        console.error('There was an API error', err);
      });
  };
}
/////////////////////END CHANGE PASSWORD//////////////////////////////////

//////////////////////RESET PASSWORD VIA TOKEN///////////////////////////////
export function setResetPasswordToken(resetPasswordToken, resetToken) {
  return (dispatch) => {
    dispatch({
      type: SET_RESET_PASSWORD_TOKEN,
      data: { resetPasswordToken, resetToken },
    });
  };
}

export function resetPasswordTokenForm(user) {
  return (dispatch) => {
    dispatch({ type: RESET_PASSWORD_TOKEN_FORM });
  };
}
export function requestUserPasswordResetToken(dataToSave, callback, error) {
  return (dispatch) => {
    dispatch({ type: USER_PASSWORD_RESET });
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'Users/resetPassword', {
      body: JSON.stringify(dataToSave),
    })
      .then(() => {
        dispatch({ type: USER_PASSWORD_RESETTED });
        var msg = APP.LANGUAGE.ResetPassword.ResetPasswordSuccess.replace(
          '##userEmail##',
          dataToSave.resetPasswordToken.PersonEmail
        );
        dispatch(
          displayGlobalMessage({
            text: msg,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (callback) callback();
      })
      .catch((err) => {
        dispatch({ type: USER_PASSWORD_RESET_FAILED });
        console.error('There was an API error', err);
      });
  };
}

//////////////////////END RESET PASSWORD VIA TOKEN///////////////////////////////
export function userLoggedIn(user) {
  return (dispatch) => {
    dispatch({ type: USER_IS_LOGGED_IN });
  };
}
export function userLoggedOut(user) {
  return (dispatch) => {
    dispatch({ type: USER_IS_LOGGED_OUT });
  };
}

export function requestUserPasswordReset(userEmail, callback, error) {
  return (dispatch) => {
    dispatch({ type: USER_PASSWORD_RESET });
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'Users/forgotpassword/', { body: JSON.stringify({ email: userEmail }) })
      .then(() => {
        dispatch({ type: USER_PASSWORD_RESETTED });
        if (callback) callback();
      })
      .catch((err) => {
        dispatch({ type: USER_PASSWORD_RESET_FAILED });
        console.error('There was an API error', err);
      });
  };
}
export function setResetPasswordForm(resetPasswordForm) {
  return (dispatch) => {
    dispatch({ type: SET_RESET_PASSWORD_FORM, data: resetPasswordForm });
  };
}
export function saveUserProfileAsync(dataToSave, cb) {
  return (dispatch, getState) => {
    dispatch({ type: SAVE_USER, data: true });
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'users', {
      body: JSON.stringify(dataToSave),
    })
      .then((returnData) => {
        //Saving the returned userImageUrl
        dataToSave.userImageUrl = returnData.imageProfileUrl;
        dispatch({ type: SAVED_USER, data: dataToSave });
        var successMessage = 'Updated your profile successfully';
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) {
          cb();
        }
      })
      .catch((err) => {
        dispatch({ type: SAVE_USER, data: false });
        console.error('There was an API error', err);
      });
  };
}

export function changeUserImageAsync(fileName, file) {
  return (dispatch) => {
    // trigger to update redux state
    dispatch({ type: CHANGE_USER_IMAGE, name: fileName, file: file });
  };
}

// because if user is updating image, we should prevent the component from reloading old image
export function ignoreReloadUserImage() {
  return { type: IGNORE_RELOAD_USER_IMAGE };
}

export function resetImageAsync() {
  return { type: RESET_IMAGE };
}

export function resetImageToDefault() {
  return { type: RESET_IMAGE_TO_DEFAULT };
}

export function setProfileImageDropped(url) {
  return { type: SET_PROFILE_IMAGE_DROPPED, data: url };
}

export function userCallStatusUpdated(isInCall) {
  return (dispatch) => {
    dispatch({ type: USER_CALL_STATUS_CHANGED, data: isInCall });
  };
}

export function getWaitingAreaUsers(waitingAreaId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_WAITING_AREA_USERS });
    };

    const apiPart = 'waitingareas/' + waitingAreaId + '/users';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb();
        let res = dispatch({
          type: GOT_WAITING_AREA_USERS,
          data: {
            users: data,
            waitingAreaId: waitingAreaId,
          },
        });
        return res;
      })
      .catch((err) => errorCallback(err));
  };
}
///////////////ORganisation Manage Users///////////////////////
export function getOrganisationalUnitUsers(organisationNetworkId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_ORGANISATIONAL_UNIT_USERS });
    };

    const apiPart = 'organisations/' + organisationNetworkId + '/users';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb();
        let res = dispatch({
          type: GOT_ORGANISATIONAL_UNIT_USERS,
          data: {
            organisationUsers: data,
            organisationNetworkId: organisationNetworkId,
          },
        });
        return res;
      })
      .catch((err) => errorCallback(err));
  };
}

export function updateOrgRolesPayload(organisationNetworkId, user, rolesForUserArray, cb) {
  return (dispatch) => {
    let apiParam = 'organisations/' + organisationNetworkId + '/userrole/' + user.id;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(rolesForUserArray),
    })
      .then((res) => {
        if (cb) cb(false);
        let successMessage = APP.LANGUAGE.ManageRolesForUsersListModal.SuccessSave.replace(
          '##firstName##',
          user.firstName
        ).replace('##lastName##', user.lastName);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );

        let getBasicInfo = () => {
          dispatch(getUserBasicProfile());
        };

        let getUsers = () => {
          dispatch(getOrganisationalUnitUsers(organisationNetworkId, getBasicInfo));
        };
        dispatch(getOrganisationById(organisationNetworkId, getUsers));
      })
      .catch((err) => {
        if (cb) cb(true);
        console.error('There was an API error', err.toString());
      });
  };
}
//////////////end Organisation Manage users///////////////////////////
function getSearchSuggestions(dispatch, searchTerm, cb) {
  let errorCallback = (response) => {
    console.error('ERROR', response);
    dispatch({ type: SEARCH_SELECT_USERS_FORM.ERROR_GETTING_SUGGESTIONS });
    dispatch({ type: SEARCH_SELECT_USERS_FORM.CLEAR_SUGGESTIONS });
  };

  fc.post(window.APP.CONFIGURATION.VCCAPI + 'users/search/', {
    body: JSON.stringify({ searchTerm: searchTerm }),
  })
    .then((data) => {
      if (cb) cb();

      // if sugesstion got more than 1 users, which had exact email in search query, select those automatically (this happens when paste in multiple email ids)
      const searchTermLC = searchTerm.toLowerCase();
      if (data.length > 1 && data.filter((user) => searchTermLC.includes(user.email.toLowerCase())).length > 1) {
        dispatch({ type: SEARCH_SELECT_USERS_FORM.CLEAR_SUGGESTIONS });
        data.forEach(
          (user) => searchTermLC.includes(user.email.toLowerCase()) && dispatch(selectUserFromSearchSuggestions(user))
        );
      }
      // if sugesstion got 1 users, which had exact email in search query and query ended on , or ; select that user automatically
      else if (
        data.length === 1 &&
        searchTermLC.includes(data[0].email.toLowerCase()) &&
        (searchTermLC.endsWith(',') || searchTermLC.endsWith(';'))
      ) {
        dispatch({ type: SEARCH_SELECT_USERS_FORM.CLEAR_SUGGESTIONS });
        dispatch(selectUserFromSearchSuggestions(data[0]));
      } else {
        dispatch({
          type: SEARCH_SELECT_USERS_FORM.SHOW_SUGGESTIONS,
          data: { searchTerm: searchTerm, searchSuggestions: data },
        });
      }
    })
    .catch((err) => errorCallback(err));
}

getSearchSuggestions = _.debounce(getSearchSuggestions, 500, { leading: true });

export function getSearchUserSuggestions(searchTerm, cb) {
  return (dispatch) => {
    if (searchTerm.length === 0) {
      // if user typed no chars, skip search and clear the search form
      dispatch({ type: SEARCH_SELECT_USERS_FORM.CLEAR_SUGGESTIONS });
      return;
    }

    dispatch({
      type: SEARCH_SELECT_USERS_FORM.LOADING_SUGGESTIONS,
      data: searchTerm,
    });

    getSearchSuggestions(dispatch, searchTerm, cb);
  };
}

export function clearSearchUserSuggestions() {
  return (dispatch) => {
    dispatch({ type: SEARCH_SELECT_USERS_FORM.CLEAR_SUGGESTIONS });
  };
}

export function clearSearchUserForm() {
  return (dispatch) => {
    dispatch({ type: SEARCH_SELECT_USERS_FORM.CLEAR_FORM });
  };
}

export function selectUserFromSearchSuggestions(selectedUser) {
  return (dispatch) => {
    dispatch({
      type: SEARCH_SELECT_USERS_FORM.SELECT_USER,
      data: selectedUser,
    });
  };
}

export function selectSingleUserFromSearchSuggestions(selectedUser) {
  return (dispatch) => {
    dispatch({
      type: SEARCH_SELECT_USERS_FORM.SELECT_SINGLE_USER,
      data: selectedUser,
    });
  };
}

export function removeUserFromSelectedUsers(userToRemove) {
  return (dispatch) => {
    dispatch({
      type: SEARCH_SELECT_USERS_FORM.UNSELECT_USER,
      data: userToRemove,
    });
  };
}

/* Manage roles For users list */
export function updateSelectedUser(userId, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SELECTED_USER_FOR_MANAGEMENT, data: userId });
    if (cb) cb();
  };
}

export function updateRolesForParticularUser(waitingAreaId, user, rolesForUser, cb, cbAfterRes) {
  return (dispatch) => {
    let apiParam = 'waitingareas/' + waitingAreaId + '/userrole/' + user.id;
    let newSelectedRoles = rolesForUser.filter((availableRolesForThisUser) => {
      return availableRolesForThisUser.selected === true;
    });
    let newRolesIdArray = [];
    newSelectedRoles.map((selectedRole) => {
      newRolesIdArray.push(selectedRole.id);
    });
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(newRolesIdArray),
    })
      .then((res) => {
        if (cb) cb(false);
        let successMessage = APP.LANGUAGE.ManageRolesForUsersListModal.SuccessSave.replace(
          '##firstName##',
          user.firstName
        ).replace('##lastName##', user.lastName);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cbAfterRes) cbAfterRes();
      })
      .catch((err) => {
        if (cb) cb(true);
        console.error('There was an API error', err.toString());
      });
  };
}

export function updateRolesPayload(waitingAreaId, user, rolesForUserArray, cb) {
  return (dispatch) => {
    let apiParam = 'waitingareas/' + waitingAreaId + '/userrole/' + user.id;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(rolesForUserArray),
    })
      .then((res) => {
        if (cb) cb(false);
        let successMessage = APP.LANGUAGE.ManageRolesForUsersListModal.SuccessSave.replace(
          '##firstName##',
          user.firstName
        ).replace('##lastName##', user.lastName);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );

        let getBasicInfo = () => {
          dispatch(getUserBasicProfile());
        };

        let getUsers = () => {
          dispatch(getWaitingAreaUsers(waitingAreaId, getBasicInfo));
        };
        queueESEvents(
          ESEventTypes.APICall,
          `In updateRolesPayload: ${waitingAreaId}`,
          'eventType&apiURL',
          {
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/calls',
            browserURL: window.location.href,
          },
          null,
          true,
          'info'
        );
        dispatch(getWaitingArea(waitingAreaId, getUsers));
      })
      .catch((err) => {
        if (cb) cb(true);
        console.error('There was an API error', err.toString());
      });
  };
}

///////////////Create Account /////////////////////////////////////////////////
export function setUserSignupForm(userWAForm) {
  return (dispatch) => {
    dispatch({
      type: SET_WA_USER_SIGNUP_FORM,
      data: userWAForm,
    });
  };
}

export function resetUserSignupForm() {
  return (dispatch) => {
    dispatch({
      type: RESET_WA_USER_SIGNUP_FORM,
    });
  };
}

export function validateUserSignupLink(jwtEmail, cb) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'Users/validateUserSignupRequest';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiParam, { body: JSON.stringify({ jwtToken: jwtEmail }) })
      .then((res) => {
        if (cb) {
          cb(true, res);
        }
      })
      .catch((err) => {
        cb(false);
        console.error('There was an API error', err.toString());
      });
  };
}

export function createSignup(userWAForm, cb) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'Users/signupUser';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(userWAForm),
    })
      .then((res) => {
        let successMessage = APP.LANGUAGE.UserSignUp.SuccessMessage.replace(
          '##Name##',
          userWAForm.firstName + ' ' + userWAForm.lastName
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) {
          cb(true, res);
        }
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        cb(false, null, err);
      });
  };
}

///////////////End Account ////////////////////////////////////////////////////

///////MANAGE MY ROLES//////////

export function getMyRoles(cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_MY_ROLES });
    };

    const apiPart = 'users/roles';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb(data);
        let res = dispatch({
          type: GOT_MY_ROLES,
          data: data,
        });
        return res;
      })
      .catch((err) => errorCallback(err));
  };
}

export function removeMyRole(personNetworkRoleId, cb) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_ROLE,
      data: personNetworkRoleId,
    });
    if (cb) cb();
  };
}
export function undoRemoveMyRole(personNetworkRoleId) {
  return (dispatch) => {
    dispatch({
      type: UNDO_REMOVE_ROLE,
      data: personNetworkRoleId,
    });
  };
}

export function undoRemoveAllRole(cb) {
  return (dispatch) => {
    dispatch({
      type: UNDO_REMOVE_ALL_ROLE,
    });
    if (cb) cb();
  };
}

export function removeAllMyRole() {
  return (dispatch) => {
    dispatch({
      type: REMOVE_ALL_ROLE,
    });
  };
}

export function updateMyRoles(removePersonNetworkRoleIds, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_UPDATING_MY_ROLES });
    };
    const apiPart = 'users/roles';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(removePersonNetworkRoleIds),
    })
      .then((data) => {
        let res = dispatch({
          type: GOT_MY_ROLES,
          data: data,
        });
        // dispatch(getMyRoles(cb));
        if (cb) cb(data);

        return res;
      })
      .catch((err) => errorCallback(err));
  };
}

export function resetMyRoles() {
  return (dispatch) => {
    dispatch({ type: RESET_MY_ROLES });
  };
}

export function updateOtherUsersRoles(removePersonNetworkRoleIds, personId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      if (cb) cb(false);
      dispatch({ type: ERROR_UPDATING_OTHER_ROLES });
    };
    const apiPart = 'users/' + personId + '/roles';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(removePersonNetworkRoleIds),
    })
      .then((data) => {
        if (cb) cb(true);
      })
      .catch((err) => errorCallback(err));
  };
}
///////END MANAGE MY ROLES//////

// Meeting Room manage users
export function getMeetingRoomUsers(meetingRoomId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
    };
    const apiPart = `meetingrooms/${meetingRoomId}/users`;

    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let meetingRoomUsers = objectAssign({}, data, { users: data.users });

        let res = dispatch({
          type: GOT_MEETING_ROOM_USERS,
          data: {
            meetingRoomUsers: meetingRoomUsers,
            meetingRoomId: meetingRoomId,
          },
        });
        if (cb) cb();
        return res;
      })
      .catch((err) => errorCallback(err));
  };
}

// Update Meeting Room User Role
export function updateRolesForMeetingRoomUser(meetingRoomId, user, rolesForUserArray, cb, cbAfterRes) {
  return (dispatch) => {
    let apiParam = 'meetingrooms/' + meetingRoomId + '/userrole/' + user.id;

    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(rolesForUserArray),
    })
      .then((res) => {
        if (cb) cb(false);
        let successMessage = APP.LANGUAGE.ManageRolesForUsersListModal.SuccessSave.replace(
          '##firstName##',
          user.firstName
        ).replace('##lastName##', user.lastName);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );

        let getBasicInfo = () => {
          dispatch(getUserBasicProfile());
        };

        let getUsers = () => {
          dispatch(getMeetingRoomUsers(meetingRoomId, getBasicInfo));
        };
        dispatch(getMeetingRoomWithSearchTerm(meetingRoomId, getUsers));
      })
      .catch((err) => {
        if (cb) cb(true);
        console.error('There was an API error', err.toString());
      });
  };
}

export function getAllUsersForAdmin(allUsersSearchForm, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_ALL_USERS_FOR_ADMIN });
    };

    const apiPart = 'Users/users';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(allUsersSearchForm),
    })
      .then((data) => {
        // Data need to do checking, if there are duplicate users then do not need to put in the store.
        // Only store the new fetched users
        // If updateOrNot == true, means is just update single user info that loaded in the list
        let res = dispatch({
          type: GOT_ALL_USERS_FOR_ADMIN,
          data: data,
        });

        if (cb) {
          if (!!data.users && Array.isArray(data.users) && data.users.length > 0) {
            // If still more users can be retrieved, set first argument to be true
            cb(true, true);
          }
          // else, set first argument to be false means should not increase current active page no.
          else cb(false, true);
        }
        return res;
      })
      .catch((err) => {
        if (cb) cb(false, false);
        errorCallback(err);
      });
  };
}

export function updateSingleUsersForAdmin(personId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_SINGLE_USERS_FOR_ADMIN });
    };

    const apiPart = 'Users/' + personId + '/userstatistics';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let dataPayload = {
          personId: personId,
          userStatus: data,
        };

        let res = dispatch({
          type: UPDATE_SINGLE_USERS_FOR_ADMIN,
          data: dataPayload,
        });

        if (cb) cb(true);

        return res;
      })
      .catch((err) => {
        if (cb) cb(false);
        errorCallback(err);
      });
  };
}

export function updateSelectedUserInAllUsersPage(user, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SELECTED_USER_FOR_ALL_USERS, data: user });
    if (cb) cb();
  };
}

export function resetAllUsersSearchForm(cb) {
  return (dispatch) => {
    dispatch({ type: RESET_ALL_USERS_SEARCH_FROM });
    if (cb) cb();
  };
}

export function updateCurrentActivePageNo(updateOffset, cb) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ALL_USERS,
      data: updateOffset,
    });
    if (cb) cb();
  };
}

export function updateAllUsersSearchBar(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ALL_USERS_SEARCH_BAR, data: searchTerm });
  };
}

export function updateAllUsersSearchForm(newAllUsersSearchForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ALL_USERS_SEARCH_FROM,
      data: newAllUsersSearchForm,
    });
  };
}

// Get User Profile by UserID
export function getUserProfileByUserId(userId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_USER_PROFILE });
    };
    const apiPart = `Users/${userId}/userprofile`;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: UPDATE_SELECTED_USER_FOR_ALL_USERS,
          data: data,
        });
        if (cb) {
          cb(true);
        }
        return res;
      })
      .catch((err) => {
        if (cb) cb(false);
        errorCallback(err);
      });
  };
}

// Get User Call List by UserID
export function getUserCallsDetails(userId) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_USER_CALLs_DETAILS });
    };
    const apiPart = `Users/${userId}/lastCallsDetail`;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_USER_CALLS_DETAILS,
          data: data,
        });
        return res;
      })
      .catch((err) => {
        errorCallback(err);
      });
  };
}

// Get user role's by personId
export function getUserRolesByUserId(userId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_MY_ROLES });
    };
    const apiPart = `Users/${userId}/roles`;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_MY_ROLES,
          data: data.roles,
        });
        dispatch(updateRolesInOtherNetworks(data.hasRolesInOtherNetworks));
        if (cb) {
          cb(true);
        }
        return res;
      })
      .catch((err) => {
        if (cb) cb(false);
        errorCallback(err);
      });
  };
}

export function updateRolesInOtherNetworks(hasRolesInOtherNetworks) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_HAS_ROLES_IN_OTHER_NETWORKS,
      data: hasRolesInOtherNetworks,
    });
  };
}

// Manage Invitations
export function getUserInvitationsByUserId(userId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_USER_INVITATIONS });
    };

    const apiPart = `Users/${userId}/invitations`;

    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_USER_INVITATIONS,
          data: data,
        });
        if (cb) {
          cb(true);
        }
        return res;
      })

      .catch((err) => {
        if (cb) cb(false);
        errorCallback(err);
      });
  };
}

export function sendReminderByUserId(userId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_RESEND_INVITATION_BY_USERID });
      if (response && response.status === 404) {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ManageInvitations.ReminderSentErrorMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
            browserURL: window.location.href,
          })
        );
      }
    };

    const apiPart = `Users/${userId}/resendinvitation`;

    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) {
          cb(true);
        }
      })

      .catch((err) => {
        if (cb) cb(false);
        errorCallback(err);
      });
  };
}
export function removeInvitedRole(personNetworkRoleId, cb) {
  return (dispatch) => {
    dispatch({
      type: INTEND_TO_REMOVE_INVITED_ROLE,
      data: personNetworkRoleId,
    });
    if (cb) cb();
  };
}
export function undoRemoveInvitedRole(personNetworkRoleId) {
  return (dispatch) => {
    dispatch({
      type: UNDO_REMOVE_INVITED_ROLE,
      data: personNetworkRoleId,
    });
  };
}

export function removeAllInvitedRoles(cb) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_ALL_INVITED_ROLES,
    });
    if (cb) cb();
  };
}

export function undoRemoveAllInvitedRoles(cb) {
  return (dispatch) => {
    dispatch({
      type: UNDO_REMOVE_ALL_INVITED_ROLES,
    });
    if (cb) cb();
  };
}

export function cancelInvitationByUserId(userId, payload, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_CANCEL_INVITATION_BY_USERID });
      if (response && response.status === 404) {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ManageInvitations.RolesRemovedErrorMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
            browserURL: window.location.href,
          })
        );
      }
    };

    const apiPart = `Users/${userId}/cancelnvitation`;

    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) {
          cb(true);
        }
      })
      .catch((err) => {
        if (cb) cb(false);
        errorCallback(err);
      });
  };
}

export function updateUserProfileWithNewEmail(email) {
  return (dispatch) => {
    dispatch({ type: UPDATE_USER_PROFILE_NEW_EMAIL, data: email });
  };
}

export function changeUserEmail(payload, successAction, failureAction) {
  const apiPart = 'Users/changeEmail';
  window.$('#overlay').show();
  fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
    body: JSON.stringify(payload),
  })
    .then((data) => {
      if (data) {
        successAction();
      } else {
        failureAction();
      }
      window.$('#overlay').hide();
    })
    .catch((err) => {
      window.$('#overlay').hide();
      failureAction(err);
    });
}
